export const OPEN_BAG = 'OPEN_BAG'
export const CLOSE_BAG = 'CLOSE_BAG'
export const TOGGLE_BAG = 'TOGGLE_BAG'
export const OPEN_LOGIN_DRAWER = 'OPEN_LOGIN_DRAWER'
export const CLOSE_LOGIN_DRAWER = 'CLOSE_LOGIN_DRAWER'
export const TOGGLE_LOGIN_DRAWER = 'TOGGLE_LOGIN_DRAWER'
export const CLOSE_OPEN_DRAWER = 'CLOSE_OPEN_DRAWER'
